import type { FC } from 'react'

import { useLocation } from 'react-router-dom'

import { useCompanyInfo } from 'core/stores'
import { UserType } from 'core/types'

import { getPageTitle } from './getPageTitle'
import PageTitle from './PageTitle'

type SetPageTitleProps = {
  userType: UserType
}

const SetPageTitle: FC<SetPageTitleProps> = ({ userType }) => {
  const { brandName } = useCompanyInfo()
  const { pathname } = useLocation()

  const title = getPageTitle({ pathname, brandName: brandName ?? '', userType }).trim()

  return <PageTitle title={title} />
}

export default SetPageTitle
